import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import CompactLayout from 'src/layouts/compact';

import { rootRoute } from './root';

const Page404 = lazy(() => import('src/sections/error/404-view'));

export const notFoundRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '404',
  component: () => <CompactLayout><Page404/></CompactLayout>,
});

